module MyProfile
{
    RequireLogin(() => InitializeUserDataView());

    export function InitializeUserDataView() {
        $("#name").val(webUser.name);
        $("#email").val(webUser.email);
        $("#countryCode").val(webUser.countryCode);
        $("#phone").val(webUser.phoneNumber);
        $("#address").val(webUser.address);
        document.getElementById('newsletterMail')["checked"] = webUser.receiveNewsletterMail;
        document.getElementById('newsletterPhone')["checked"] = webUser.receiveNewsletterPhone;
        var hasCard = webUser.subscriptionType == CustomerAPI.PaymentType.Stripe && webUser.paymentCardNumber != null && webUser.paymentCardNumber.length > 0;
        $('#PaymentCard').html(hasCard ? webUser.paymentCardNumber : localizer["MyProfileNoCard"]);
        $("#ChangeCardLink").html(hasCard ? localizer["MyProfileChangeCard"] : localizer["MyProfileAddCard"]);
        if (!hasCard) {
            $("#RemoveCardsButton").hide();
        }
    }

    export function SaveUserData() {
        $('#SaveStatus').removeClass('text-success');
        $('#SaveStatus').removeClass('text-danger');

        $('#SaveButton').prop('disabled', true);
        $('#SaveButton').html(localizer["MyProfileSaveStarted"]);

        SaveUserDataInternal(() => {
            $('#SaveButton').html(localizer["MyProfileSaveDone"]);
            
            setTimeout(ResetSaveButton, 2000);

            //Alert.OpenSuccess(localizer["MyProfileSaveSuccess"], "");
			//$('#SaveStatus').addClass('text-success');
			//$('#SaveStatus').html('Lagring fullført');//TODO: Localize
        }, failReason => {
            Alert.OpenError(localizer["MyProfileSaveFailed"], failReason);

            ResetSaveButton();

			//$('#SaveStatus').addClass('text-success');
			//$('#SaveStatus').html(failReason);
        })
    }

    export function ResetSaveButton() {
        $('#SaveButton').html(localizer["MyProfileSave"]);
        $('#SaveButton').prop('disabled', false);
    }

    export function SaveUserDataInternal(onSuccess: () => void, onFail?: (reason: string) => void) {
        webUser.name = $("#name").val();
        webUser.email = $("#email").val();
        webUser.countryCode = $("#countryCode").val();
        webUser.phoneNumber = $("#phone").val();
        webUser.address = $("#address").val();

        webUser.receiveNewsletterPhone = document.getElementById('newsletterPhone')["checked"];
        webUser.receiveNewsletterMail = document.getElementById('newsletterMail')["checked"];

        CustomerAPI.customerAPI.setUserData(window.location.href, webUser, () => onSuccess(), (ex, reason) => onFail((<CustomerAPI.WebError>ex).message));
    }
}